  document.addEventListener('DOMContentLoaded', function () {
    const bank = document.getElementById('exercise-bank');
    const chips = document.querySelectorAll('.exercise-chip');
    const cards = document.querySelectorAll('.exercise-card');
    const grid = document.getElementById('exercise-grid');
    const searchInput = document.getElementById('exercise-number-search');
    const noResults = document.getElementById('exercise-no-results');
    const selectedBar = document.getElementById('exercise-selected-bar');
    const selectedList = document.getElementById('exercise-selected-list');
    const selectedListCol = document.querySelector('.exercise-selected-col--list');
    const clearSelectionButton = document.getElementById('exercise-clear-selection');
    const addButtons = document.querySelectorAll('.js-add-exercise');
    const toggleSelectedButton = document.getElementById('exercise-toggle-selected');
    const copyLinkButton = document.getElementById('exercise-copy-link');
    const sendLinkButton = document.getElementById('exercise-send-link');
    const qrImage = document.getElementById('exercise-qr-image');
    const qrImagePreview = document.getElementById('exercise-qr-image-preview');
    const selectedCountEl = document.getElementById('exercise-selected-count');
    const totalCountEl = document.getElementById('exercise-total-count');
    const validExerciseIds = new Set(
      Array.from(cards)
        .map((card) => (card.dataset.number || '').trim())
        .filter(Boolean)
    );

    let activeCategory = '';
    let selectedIds = [];
    let showOnlySelected = false;
    let patientMode = false;
    let currentFullPatientLink = '';
    const totalExercises = parseInt(bank?.dataset.totalExercises || '0', 10);
    const copyDefaultLabel = 'Kopiér link';
    const copySuccessLabel = 'Kopieret';
    const copyErrorLabel = 'Kunne ikke kopiere';

    function setCopyButtonLabel(label) {
      if (!copyLinkButton) return;
      copyLinkButton.innerHTML =
        '<span class="exercise-patient-tools__copy-icon" aria-hidden="true">' +
        '<svg viewBox="0 0 20 20" focusable="false">' +
        '<path d="M7 3.5A1.5 1.5 0 0 0 5.5 5v8A1.5 1.5 0 0 0 7 14.5h6a1.5 1.5 0 0 0 1.5-1.5V5A1.5 1.5 0 0 0 13 3.5H7Zm0-1h6A2.5 2.5 0 0 1 15.5 5v8a2.5 2.5 0 0 1-2.5 2.5H7A2.5 2.5 0 0 1 4.5 13V5A2.5 2.5 0 0 1 7 2.5Z"/>' +
        '<path d="M4 6.5a.5.5 0 0 1 .5.5v8A1.5 1.5 0 0 0 6 16.5h6a.5.5 0 0 1 0 1H6A2.5 2.5 0 0 1 3.5 15V7a.5.5 0 0 1 .5-.5Z"/>' +
        '</svg>' +
        '</span>' +
        label;
    }

    function parseIds(value) {
      if (!value) return [];
      return value
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
    }

    function uniqueIds(ids) {
      return [...new Set(ids)];
    }

    function normalizeSelectedIds(ids) {
      return uniqueIds(ids).filter((id) => validExerciseIds.has(id));
    }

    function getIdsFromUrl() {
      const params = new URLSearchParams(window.location.search);
      return parseIds(params.get('ids'));
    }

    function buildPatientLink(ids) {
      const url = new URL(window.location.href);
      url.searchParams.delete('ids');
      url.searchParams.delete('selected_only');
      url.searchParams.delete('patient');

      if (ids.length) {
        url.searchParams.set('ids', ids.join(','));
        url.searchParams.set('patient', '1');
      }

      return { full: url.toString() };
    }

    function setIdsInUrl(ids) {
      const url = new URL(window.location.href);

      if (ids.length) {
        url.searchParams.set('ids', ids.join(','));
      } else {
        url.searchParams.delete('ids');
      }

      if (showOnlySelected && ids.length) {
        url.searchParams.set('selected_only', '1');
      } else {
        url.searchParams.delete('selected_only');
      }

      if (patientMode && ids.length) {
        url.searchParams.set('patient', '1');
      } else {
        url.searchParams.delete('patient');
      }

      window.history.replaceState({}, '', url.toString());
    }

    function sortCardsByNumber() {
      if (!grid) return;

      const cardsArray = Array.from(grid.querySelectorAll('.exercise-card'));

      cardsArray.sort((a, b) => {
        const aNum = parseInt((a.dataset.number || '').replace(/\D/g, ''), 10);
        const bNum = parseInt((b.dataset.number || '').replace(/\D/g, ''), 10);

        if (isNaN(aNum) && isNaN(bNum)) return 0;
        if (isNaN(aNum)) return 1;
        if (isNaN(bNum)) return -1;

        return aNum - bNum;
      });

      cardsArray.forEach((card) => grid.appendChild(card));
    }

    function updateButtonCounts() {
      if (selectedCountEl) {
        selectedCountEl.textContent = '(' + selectedIds.length + ')';
      }
      if (totalCountEl) {
        totalCountEl.textContent = '(' + totalExercises + ')';
      }
    }

    function updateViewButtons() {
      if (toggleSelectedButton) {
        toggleSelectedButton.classList.toggle('is-active', showOnlySelected && selectedIds.length > 0);
        toggleSelectedButton.setAttribute('aria-pressed', showOnlySelected && selectedIds.length > 0 ? 'true' : 'false');
      }

      if (clearSelectionButton) {
        clearSelectionButton.classList.toggle('is-active', !showOnlySelected);
        clearSelectionButton.setAttribute('aria-pressed', !showOnlySelected ? 'true' : 'false');
      }
    }

    function renderSelectedList() {
      if (!selectedList) return;

      selectedList.innerHTML = '';

      selectedIds.forEach((id) => {
        const card = document.querySelector('.exercise-card[data-number="' + CSS.escape(id) + '"]');
        const title = card ? card.getAttribute('data-title') : id;

        const pill = document.createElement('div');
        pill.className = 'exercise-selected-pill';
        pill.innerHTML = '<span>' + id + ' · ' + title + '</span><button type="button" data-remove-id="' + id + '">×</button>';
        selectedList.appendChild(pill);
      });

      selectedList.querySelectorAll('[data-remove-id]').forEach((button) => {
        button.addEventListener('click', function () {
          const id = this.getAttribute('data-remove-id');
          selectedIds = normalizeSelectedIds(selectedIds.filter((item) => item !== id));

          if (searchInput) searchInput.value = selectedIds.join(',');
          if (!selectedIds.length) showOnlySelected = false;

          setIdsInUrl(selectedIds);
          updateAddButtons();
          updateSelectedCardState();
          updateButtonCounts();
          renderSelectedList();
          updatePatientTools();
          applyFilters();
        });
      });

      updateSelectedListScrollHint();
    }

    function updateSelectedListScrollHint() {
      if (!selectedList || !selectedListCol) return;

      const isScrollable = selectedList.scrollWidth > selectedList.clientWidth + 2;
      const atEnd = selectedList.scrollLeft + selectedList.clientWidth >= selectedList.scrollWidth - 2;

      selectedListCol.setAttribute('data-scrollable', isScrollable ? 'true' : 'false');
      selectedListCol.setAttribute('data-at-end', atEnd ? 'true' : 'false');
    }

    function updateAddButtons() {
      addButtons.forEach((button) => {
        const id = button.getAttribute('data-number');
        if (selectedIds.includes(id)) {
          button.classList.add('is-added');
          button.textContent = 'Valgt';
        } else {
          button.classList.remove('is-added');
          button.textContent = 'Gem';
        }
      });
    }

    function updateSelectedCardState() {
      cards.forEach((card) => {
        const id = (card.dataset.number || '').trim();
        if (selectedIds.includes(id)) {
          card.classList.add('is-selected');
        } else {
          card.classList.remove('is-selected');
        }
      });
    }

    function updateNoResults() {
      const visibleCards = document.querySelectorAll('.exercise-card:not(.hidden)');
      noResults.style.display = visibleCards.length ? 'none' : 'block';
    }

    function updateSelectedBar() {
      if (patientMode) {
        selectedBar.style.display = 'none';
        return;
      }

      selectedBar.style.display = selectedIds.length ? 'block' : 'none';
    }

    function updatePatientTools() {
      const patientLink = buildPatientLink(selectedIds);
      currentFullPatientLink = selectedIds.length ? patientLink.full : '';

      if (sendLinkButton) {
        if (currentFullPatientLink) {
          sendLinkButton.dataset.patientLink = currentFullPatientLink;
        } else {
          delete sendLinkButton.dataset.patientLink;
        }
      }

      if (qrImage) {
        if (selectedIds.length) {
          const qrUrl = 'https://api.qrserver.com/v1/create-qr-code/?size=240x240&data=' + encodeURIComponent(patientLink.full);
          qrImage.src = qrUrl;
          qrImage.style.display = 'block';

          if (qrImagePreview) {
            qrImagePreview.src = qrUrl;
            qrImagePreview.style.display = 'block';
          }
        } else {
          qrImage.removeAttribute('src');
          qrImage.style.display = 'none';
          if (qrImagePreview) {
            qrImagePreview.removeAttribute('src');
            qrImagePreview.style.display = 'none';
          }
        }
      }
    }

    function applyFilters() {
      cards.forEach((card) => {
        const cardCategory = (card.dataset.category || '').trim().toLowerCase();
        const cardNumber = (card.dataset.number || '').trim();

        const categoryMatch = patientMode ? true : (!activeCategory || cardCategory === activeCategory.toLowerCase());
        const selectedMatch = patientMode
          ? selectedIds.includes(cardNumber)
          : (!showOnlySelected || selectedIds.includes(cardNumber));

        if (categoryMatch && selectedMatch) {
          card.classList.remove('hidden');
        } else {
          card.classList.add('hidden');
        }
      });

      updateNoResults();
      updateSelectedBar();
      updatePatientTools();
      updateViewButtons();
    }

    chips.forEach((chip) => {
      chip.addEventListener('click', function () {
        chips.forEach((item) => item.classList.remove('is-active'));
        this.classList.add('is-active');
        activeCategory = this.getAttribute('data-category') || '';
        applyFilters();
      });
    });

    const cardCategoryButtons = document.querySelectorAll('.js-filter-category');
    cardCategoryButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const category = this.getAttribute('data-category') || '';
        activeCategory = category;

        chips.forEach((chip) => {
          const chipCategory = chip.getAttribute('data-category') || '';
          chip.classList.toggle('is-active', chipCategory === category);
        });

        applyFilters();

        const filtersWrap = document.getElementById('exercise-category-filters');
        if (filtersWrap) {
          filtersWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        selectedIds = normalizeSelectedIds(parseIds(this.value.trim()));
        showOnlySelected = false;

        setIdsInUrl(selectedIds);
        updateAddButtons();
        updateSelectedCardState();
        updateButtonCounts();
        renderSelectedList();
        applyFilters();
      });
    }

    addButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const id = this.getAttribute('data-number');
        if (!id) return;

        if (selectedIds.includes(id)) {
          selectedIds = selectedIds.filter((item) => item !== id);
        } else {
          selectedIds.push(id);
        }

        selectedIds = normalizeSelectedIds(selectedIds);

        if (searchInput) searchInput.value = selectedIds.join(',');
        if (!selectedIds.length) showOnlySelected = false;

        setIdsInUrl(selectedIds);
        updateAddButtons();
        updateSelectedCardState();
        updateButtonCounts();
        renderSelectedList();
        applyFilters();
      });
    });

    if (toggleSelectedButton) {
      toggleSelectedButton.addEventListener('click', function () {
        if (!selectedIds.length) return;
        showOnlySelected = true;
        activeCategory = '';

        chips.forEach((chip, index) => {
          chip.classList.toggle('is-active', index === 0);
        });

        setIdsInUrl(selectedIds);
        applyFilters();
      });
    }

    if (selectedList) {
      selectedList.addEventListener('scroll', updateSelectedListScrollHint, { passive: true });
    }

    window.addEventListener('resize', updateSelectedListScrollHint);

    if (clearSelectionButton) {
      clearSelectionButton.addEventListener('click', function () {
        showOnlySelected = false;
        activeCategory = '';

        chips.forEach((chip, index) => {
          chip.classList.toggle('is-active', index === 0);
        });

        setIdsInUrl(selectedIds);
        applyFilters();
      });
    }

    if (copyLinkButton) {
      setCopyButtonLabel(copyDefaultLabel);
      copyLinkButton.addEventListener('click', async function () {
        if (!currentFullPatientLink) return;

        try {
          await navigator.clipboard.writeText(currentFullPatientLink);
          setCopyButtonLabel(copySuccessLabel);
          setTimeout(() => {
            setCopyButtonLabel(copyDefaultLabel);
          }, 1500);
        } catch (e) {
          setCopyButtonLabel(copyErrorLabel);
          setTimeout(() => {
            setCopyButtonLabel(copyDefaultLabel);
          }, 1500);
        }
      });
    }

    const sendModal = document.getElementById('exercise-send-modal');
    const sendLinkForm = document.getElementById('exercise-send-link-form');
    const sendEmailInput = document.getElementById('exercise-send-email');
    const sendMessage = document.getElementById('exercise-send-message');
    const closeSendButtons = document.querySelectorAll('.js-close-send-link');

    function updateSendModalState() {
      if (!sendModal || !sendMessage) return;

      const messageText = sendMessage.textContent.trim().toLowerCase();
      const isSuccess = messageText.includes('sendt');
      sendModal.classList.toggle('is-success', isSuccess);
    }

    function openSendLinkModal() {
      if (!sendModal || !currentFullPatientLink) return;

      if (sendEmailInput) {
        sendEmailInput.value = '';
      }

      if (sendMessage) {
        sendMessage.textContent = '';
      }
      sendModal.classList.remove('is-success');
      sendModal.classList.add('is-open');
      sendModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('exercise-modal-open');

      if (sendEmailInput) {
        sendEmailInput.focus();
      }
    }

    function closeSendLinkModal() {
      if (!sendModal) return;

      sendModal.classList.remove('is-open');
      sendModal.classList.remove('is-success');
      sendModal.setAttribute('aria-hidden', 'true');

      const videoModal = document.getElementById('exercise-video-modal');
      if (!videoModal || !videoModal.classList.contains('is-open')) {
        document.body.classList.remove('exercise-modal-open');
      }
    }

    if (sendLinkButton) {
      sendLinkButton.addEventListener('click', openSendLinkModal);
    }

    closeSendButtons.forEach((button) => {
      button.addEventListener('click', closeSendLinkModal);
    });

    if (sendLinkForm) {
      sendLinkForm.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!currentFullPatientLink || !sendEmailInput) return;

        const email = sendEmailInput.value.trim();
        if (!email) return;

        document.dispatchEvent(
          new CustomEvent('exercise:send-link', {
            detail: {
              email: email,
              link: currentFullPatientLink
            }
          })
        );
      });
    }

    if (sendMessage) {
      new MutationObserver(updateSendModalState).observe(sendMessage, {
        childList: true,
        characterData: true,
        subtree: true
      });
      updateSendModalState();
    }

    const params = new URLSearchParams(window.location.search);
    selectedIds = normalizeSelectedIds(getIdsFromUrl());
    showOnlySelected = params.get('selected_only') === '1';
    patientMode = params.get('patient') === '1' && selectedIds.length > 0;

    if (patientMode) {
      bank.classList.add('is-patient-mode');
      showOnlySelected = true;
    }

    if (selectedIds.length && searchInput) {
      searchInput.value = selectedIds.join(',');
    }

    sortCardsByNumber();
    updateAddButtons();
    updateSelectedCardState();
    updateButtonCounts();
    renderSelectedList();
    applyFilters();
    if (bank) {
      bank.classList.remove('is-loading');
      bank.classList.add('is-ready');
    }

    const modal = document.getElementById('exercise-video-modal');
    const iframe = document.getElementById('exercise-video-iframe');
    const title = document.getElementById('exercise-video-modal-title');
    const openButtons = document.querySelectorAll('.js-open-video');
    const closeButtons = document.querySelectorAll('.js-close-video');

    function convertToEmbedUrl(url) {
      if (!url) return '';

      try {
        const parsed = new URL(url);

        if (parsed.hostname.includes('youtube.com')) {
          const videoId = parsed.searchParams.get('v');
          if (videoId) {
            return 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
          }

          if (parsed.pathname.includes('/embed/')) {
            return url + (url.includes('?') ? '&' : '?') + 'autoplay=1&rel=0';
          }
        }

        if (parsed.hostname.includes('youtu.be')) {
          const videoId = parsed.pathname.replace('/', '');
          if (videoId) {
            return 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
          }
        }

        if (parsed.hostname.includes('vimeo.com')) {
          const parts = parsed.pathname.split('/').filter(Boolean);
          const videoId = parts[0];
          if (videoId) {
            return 'https://player.vimeo.com/video/' + videoId + '?autoplay=1';
          }
        }

        return url;
      } catch (e) {
        return url;
      }
    }

    function openVideo(videoUrl, videoTitle) {
      const embedUrl = convertToEmbedUrl(videoUrl);
      iframe.src = embedUrl;
      title.textContent = videoTitle || 'Øvelsesvideo';
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('exercise-modal-open');
    }

    function closeVideo() {
      iframe.src = '';
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('exercise-modal-open');
    }

    openButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const url = this.getAttribute('data-video-url');
        if (!url) return;
        openVideo(url, this.getAttribute('data-video-title'));
      });
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeVideo);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      if (sendModal && sendModal.classList.contains('is-open')) {
        closeSendLinkModal();
        return;
      }

      if (modal && modal.classList.contains('is-open')) {
        closeVideo();
      }
    });
  });
